import React from "react";
import {
  DashboardOutlined,
  FileSearchOutlined,
  TeamOutlined,
  DesktopOutlined,
  HomeOutlined,
  SettingOutlined,
  BellOutlined,
  MailOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UserSwitchOutlined,
  CloudServerOutlined,
} from "@ant-design/icons";
import { Usage, Workspace, B2C, IDCard } from "../../../icons";
import { ROUTES } from "../../../constants/routesConstants";
import "./sidebarStyle.scss";
import InvoiceIcon from "../../../icons/InvoiceIcon";
import ReportsIcon from "../../../icons/ReportIcon";
import VmInsightIcon from "../../../icons/VMInsightIcon";
import PublicVMIcon from "../../../icons/PublicVMIcon";

const foldUnfoldMenu = [
  {
    menuType: "main",
    key: "collapseIcon",
    icon: <MenuFoldOutlined className="iiht-sidebar-icons" />,
  },
  {
    menuType: "main",
    key: "openIcon",
    icon: <MenuUnfoldOutlined className="iiht-sidebar-icons" />,
  },
  {
    menuType: "main",
    key: "dashboard",
    path: ROUTES.DASHBOARD,
    icon: <DashboardOutlined className="iiht-sidebar-icons" />,
    title: "dashboard",
    className: "portal-dashboard",
    label: "Dashboard",
  },
];

const userManagement = {
  menuType: "main",
  title: "userManagementTitle",
  key: "users",
  icon: <HomeOutlined className="iiht-sidebar-icons" />,
  path: ROUTES.USER_MANAGEMENT,
  className: "portal-user-management",
  label: "User Management",
};

const resellerLicense = {
  menuType: "main",
  title: "Reseller License",
  key: "users",
  icon: <IDCard className="iiht-sidebar-icons" width="19.1px" height="17.472px" fill="#039be5" />,
  path: ROUTES.RESELLERLICENSE,
  className: "portal-user-management",
  label: "Reseller License",
};

const usage = {
  menuType: "main",
  title: "Usage",
  key: "usage-report",
  icon: <Usage className="iiht-sidebar-icons" />,
  className: "portal-usage",
  path: ROUTES.USAGE,
  label: "Usage",
};

const myLabs = {
  menuType: "main",
  title: "myLabsTitle",
  key: "vm",
  className: "portal-mylabsb2c",
  icon: <DesktopOutlined className="iiht-sidebar-icons" />,
  path: ROUTES.MY_LABS,
  label: "myLabsTitle",
};
const myLabsOptions = {
  menuType: "subMenu",
  title: "common.labs",
  key: "vm",
  className: "portal-mylabs",
  icon: <DesktopOutlined className="iiht-sidebar-icons" />,
  subMenu: [
    {
      title: "myLabsTitle",
      key: "vm",
      path: ROUTES.MY_LABS,
      className: "portal-mylabs",
    },
    // Will be changed when login workspace portal page is implemented
    // {
    //   title: "workspace.workspace",
    //   key: "notification_templates",
    //   path: ROUTES.USER_WORKSPACE,
    // },
    {
      title: "workspace.workspace",
      key: "user_dashbpard_workspace",
      className: "portal-workspacemanager",
      path: ROUTES.USER_WORKSPACE_DASHBOARD,
    },
  ],
};

const notificationManager = {
  menuType: "subMenu",
  title: "Notification Manager",
  key: "notification_templates",
  icon: <BellOutlined className="iiht-sidebar-icons" />,
  subMenu: [
    {
      title: "Manage Notifications",
      key: "notification_templates",
      path: ROUTES.NOTIFICATION_MANAGEMENT,
    },
    {
      title: "Notifications",
      key: "notification_master",
      path: ROUTES.NOTIFICATIONS,
    },
  ],
};

const vmInsight = {
  menuType: "main",
  title: "vmInsight.title",
  className: "portal-vmInsight",
  key: "vminsights",
  path: ROUTES.VM_INSIGHT,
  icon: <VmInsightIcon className="iiht-sidebar-icons" />,
  label: "VM Insights",
};

const reports = {
  menuType: "subMenu",
  title: "reporting.title",
  key: "vminsights",
  icon: <ReportsIcon className="iiht-sidebar-icons" />,
  label: "Reports",
  subMenu: [
    {
      title: "reporting.title",
      key: "custom_reports",
      path: ROUTES.CUSTOM_REPORT,
    },
    {
      title: "User Month Reports",
      key: "vm_usage_and_billing",
      path: ROUTES.VM_USAGE_AND_BILLING,
      className: "portal-vm-usage-billing",
    }
  ]
};

const reports_lab_admin = {
  menuType: "subMenu",
  title: "Reports",
  key: "vm_usage_and_billing",
  icon: <ReportsIcon className="iiht-sidebar-icons" />,
  label: "Reports",
  subMenu: [
    {
      title: "User month reports",
      key: "vm_usage_and_billing",
      path: ROUTES.VM_USAGE_AND_BILLING,
      className: "portal-vm-usage-billing",
    }
  ]
};

const invoicing = {
  menuType: "main",
  title: "invoicing.title",
  className: "portal-invoicing",
  key: "vminsights",
  path: ROUTES.INVOICES,
  icon: <InvoiceIcon className="iiht-sidebar-icons" />,
  label: "Invoices",
};

const actionLog = {
  title: "Action Logs",
  key: "action_logs",
  path: ROUTES.ACTION_LOG,
  label: "Action Logs",
};

const vmUsageAndBillingMenuTenantAdmin = {
  menuType: "main",
  title: "Reports",
  key: "vm_usage_and_billing",
  icon: <DashboardOutlined className="iiht-sidebar-icons" />,
  className: "portal-vm-usage-billing",
  path: ROUTES.VM_USAGE_AND_BILLING,
  label: "Reports",
};

const roleManagement = {
  title: "rolesManagement",
  key: "role_management",
  path: ROUTES.RBAC_MANAGE_HOME,
};

const notificationSettingsManagement = {
  title: "Notification Settings",
  key: "notification_settings",
  path: ROUTES.NOTIFICATION_SETTINGS,
};

const notificationSettingsManagement_main = {
  menuType: "main",
  title: "Notification Settings",
  key: "user/notification_settings",
  icon: <BellOutlined className="iiht-sidebar-icons" />,
  path: ROUTES.NOTIFICATION_SETTINGS,
  className: "portal-notification-settings",
  label: "Notification Settings",
};

export const workspaceMenu = {
  menuType: "main",
  key: "dashboard",
  path: ROUTES.WORKSPACE_MANAGER,
  icon: <Workspace className="iiht-sidebar-icons" />,
  title: "workspace.title",
  className: "portal-workspace",
  label: "Workspace Manager",
};

let notificationManager_CSM = { ...notificationManager };
notificationManager_CSM.subMenu = [...notificationManager_CSM.subMenu, notificationSettingsManagement];

const tenantManagement_main = {
  menuType: "subMenu",
  title: "tenantManagement",
  key: "tenants",
  icon: <HomeOutlined className="iiht-sidebar-icons" />,
  subMenu: [
    {
      title: "userManagement.tenants",
      key: "tenant_list",
      path: ROUTES.TENANT_MANAGEMENT,
    },
    {
      title: "userManagementTitle",
      key: "user_management",
      path: ROUTES.USER_MANAGEMENT,
    },
  ],
};

const machineCatalog = {
  menuType: "subMenu",
  title: "machineCatalog",
  key: "catalogues",
  icon: <FileSearchOutlined className="iiht-sidebar-icons" />,
  subMenu: [
    {
      title: "machineCatalog",
      key: "catalogues",
      path: ROUTES.MACHINE_CATALOGUE,
    },
    {
      title: "tenantCatalog",
      key: "catalogues",
      path: ROUTES.TENANT_CATALOGUE,
    },
  ],
};

const publicResourceManagerMenu = {
  menuType: "subMenu",
  title: "Public Cloud VM",
  key: "public_resource",
  icon: <PublicVMIcon className="iiht-sidebar-icons" />,
  path: "publicResourceManager",
  subMenu: [
    {
      title: "manageVM",
      key: "public_resource_provider_VM",
      path: ROUTES.PUBLIC_RESOURCE_MANAGE_VM,
    }
  ],
};

const menu_group = [
  ...foldUnfoldMenu,

  {
    menuType: "main",
    key: "catalogue_sku",
    path: ROUTES.USER_MACHINE_CATALOG,
    icon: <FileSearchOutlined className="iiht-sidebar-icons" />,
    title: "machineCatalog",
    label: "Machine Catalog",
  },
  machineCatalog,
  {
    menuType: "subMenu",
    title: "B2C",
    key: "catalogue-sku-b2c",
    icon: <UserSwitchOutlined className="iiht-sidebar-icons" />,
    path: "b2c",
    subMenu: [
      {
        title: "B2C Labs",
        key: "catalogue-sku-b2c",
        path: ROUTES.B2C_LABS,
      },

      {
        title: "Plans",
        key: "plan",
        path: ROUTES.B2C_PLANS,
      },
    ],
  },
  {
    menuType: "main",
    title: "requestManagerTitle",
    path: ROUTES.REQUEST_MANAGER,
    key: "requests",
    icon: <MailOutlined className="iiht-sidebar-icons" />,
    label: "Request Manager",
  },
  {
    menuType: "subMenu",
    title: "resourceManager",
    key: "resource_provider",
    icon: <TeamOutlined className="iiht-sidebar-icons" />,
    path: "resourceManager",
    subMenu: [
      {
        title: "ResourceProvider",
        key: "resource_provider",
        path: ROUTES.RESOURCE_PROVIDER_HOME,
      },
      {
        title: "manageVM",
        key: "vm",
        path: ROUTES.MANAGE_VM,
      },
      {
        title: "manageInstanceSize",
        key: "manage_instance_size",
        path: ROUTES.MANAGE_INSTANCE_SIZE,
      },
    ],
  },
  publicResourceManagerMenu,
  {
    menuType: "subMenu",
    title: "tenantManagement",
    key: "tenants",
    icon: <HomeOutlined className="iiht-sidebar-icons" />,
    subMenu: [
      {
        title: "userManagement.tenants",
        key: "tenant_list",
        path: ROUTES.TENANT_MANAGEMENT,
      },

      {
        title: "userManagementTitle",
        key: "user_management",
        path: ROUTES.USER_MANAGEMENT,
      },
    ],
  },
  workspaceMenu,
  usage,
  notificationManager,
];

const machineCatalogSubMenu = {
  menuType: "subMenu",
  title: "machineCatalog",
  className: "portal-machine-catalog",
  key: "catalogue_sku",
  icon: <FileSearchOutlined className="iiht-sidebar-icons" />,
  subMenu: [
    {
      title: "machineCatalog",
      key: "catalogues",
      path: ROUTES.USER_MACHINE_CATALOG,
    },
    {
      title: "tenantCatalog",
      key: "catalogues",
      path: ROUTES.TENANT_CATALOGUE,
    },
  ],
};

const machineCatalogMainMenu = {
  menuType: "main",
  key: "catalogue_sku",
  title: "machineCatalog",
  className: "portal-machine-catalog",
  icon: <FileSearchOutlined className="iiht-sidebar-icons" />,
  path: ROUTES.USER_MACHINE_CATALOG,
};

const menu_group_1 = [
  ...foldUnfoldMenu,

  {
    menuType: "main",
    key: "catalogues",
    path: ROUTES.MACHINE_CATALOGUE,
    icon: <FileSearchOutlined className="iiht-sidebar-icons" />,
    title: "machineCatalog",
    className: "portal-machine-catalog",
    label: "Machine Catalog",
  },
  {
    menuType: "subMenu",
    title: "B2C",
    key: "b2c",
    icon: <HomeOutlined className="iiht-sidebar-icons" />,
    path: "b2c",
    subMenu: [
      {
        title: "B2C Labs",
        key: "B2C Labs",
        path: ROUTES.B2C_LABS,
      },

      {
        title: "Plans",
        key: "plans",
        path: ROUTES.B2C_PLANS,
      },
    ],
  },

  {
    menuType: "main",
    title: "requestManagerTitle",
    path: ROUTES.REQUEST_MANAGER,
    key: "requests",
    icon: <MailOutlined className="iiht-sidebar-icons" />,
    className: "portal-request-manager",
    label: "Request Manager",
  },
];

const cloudLabsMonitor = {
  menuType: "main",
  title: "Cloud Labs",
  key: "cloud-lab-dashboard",
  icon: <CloudServerOutlined className="iiht-sidebar-icons" />,
  path: "/cloud-labs-monitor/dashboard",
  className: "portal-cloud-labs-monitor",
  label: "Cloud Labs",
};

export const admin_data = [
  ...menu_group,
  cloudLabsMonitor,
  {
    menuType: "subMenu",
    title: "Settings",
    key: "settings",
    icon: <SettingOutlined className="iiht-sidebar-icons" />,
    subMenu: [actionLog, roleManagement, notificationSettingsManagement],
  },
  reports,
  vmInsight,
  invoicing,
  resellerLicense,
];

let labAdmin_menu_group = [...menu_group];
labAdmin_menu_group.splice(3, 1);
labAdmin_menu_group.splice(4, 1);

export const lab_admin = [
  ...labAdmin_menu_group,
  cloudLabsMonitor,
  {
    menuType: "subMenu",
    title: "Settings",
    key: "settings",
    icon: <SettingOutlined className="iiht-sidebar-icons" />,
    subMenu: [roleManagement, notificationSettingsManagement],
  },
  reports_lab_admin,
  vmInsight,
];

const manageVm = {
  menuType: "main",
  title: "manageVM",
  key: "vm",
  path: ROUTES.MANAGE_VM,
  icon: <TeamOutlined className="iiht-sidebar-icons" />,
  className: "portal-manage-vm",
  label: "Manage VM",
};
let tenant_admin_main_machineC_submenu = [...menu_group_1];
tenant_admin_main_machineC_submenu.splice(3, 0, machineCatalogSubMenu);
export const csm_data = [
  ...tenant_admin_main_machineC_submenu,
  tenantManagement_main,
  workspaceMenu,
  manageVm,
  usage,
  notificationManager_CSM,
  vmInsight,
  //invoicing,
];

let tenant_admin_main_machineC_menu = [...menu_group_1];
// tenant_admin_main_machineC_menu.splice(3, 0, machineCatalogMainMenu);
tenant_admin_main_machineC_menu.splice(3, 1, machineCatalogMainMenu);

// currently tenant catalog menu is hide for tenant admin.
export const tenant_admin = [
  ...tenant_admin_main_machineC_menu,
  // ...tenant_admin_main_machineC_submenu,
  userManagement,
  workspaceMenu,
  manageVm,
  usage,
  notificationSettingsManagement_main,
  vmInsight,
  vmUsageAndBillingMenuTenantAdmin
];
export const tenant_admin_noworkspace = [
  ...tenant_admin_main_machineC_submenu,
  userManagement,
  manageVm,
  usage,
  notificationSettingsManagement_main,
  // vmUsageAndBillingMenuTenantAdmin,
];

export const b2c_end_user = [...foldUnfoldMenu, machineCatalogMainMenu, myLabs, usage, invoicing];

export const tenant_user_workspace_and_portal = [
  ...tenant_admin_main_machineC_menu,
  myLabsOptions,
  usage,
  notificationSettingsManagement_main,
  vmInsight,
];

export const tenant_user_portal = [...tenant_admin_main_machineC_menu, myLabs, usage, notificationSettingsManagement_main, vmInsight];
